export const baseUrl = setBaseUrl();
function setBaseUrl() {
  let apiUrl;
  if (window.location.hostname === "localhost") {
    if (window.location.port && window.location.port === "3000") {
      apiUrl = `//${window.location.hostname}:13201`;
    } else {
      apiUrl = `//localhost:${window.location.port}`;
    }
  } else {
    if (window.location.port === "3000") {
      apiUrl = `//${window.location.hostname}:13201`;
    } else if (window.location.port && window.location.port !== "80") {
      apiUrl = `//${window.location.hostname}:${window.location.port}`;
    } else {
      apiUrl = `//${window.location.hostname}`;
    }
  }
  apiUrl = `${apiUrl}/api`;
  return apiUrl;
}
function getCookie(name) {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}
export function getJwtToken() {
  var cookieToken = getCookie("td6Token");
  if (cookieToken !== null) {
    return cookieToken;
  }
  return window.localStorage.getItem("td6Token");
}
let _apiUrl = "";
export function getNewUrl() {
  return _apiUrl;
}
export const pdfFileType = "application/pdf";
export const tifFileType = "image/tif";
export const tiffFileType = "image/tiff";
export const octetStream = "application/octet-stream";
export const zipFileType = "application/zip, application/x-zip-compressed";
export const csvFileType = "text/csv";
